export function generateEventName(eventName: string, isMobile = false) {
  // Mobileではない場合にPCの扱いでイベント名を設定
  return isMobile ? `sp_${eventName}` : `pc_${eventName}`;
}

export function generateEventNameSuffix(eventName: string, suffix: string) {
  return `${eventName}_${suffix}`;
}
